import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';
import SkeletonLoader from '../../../molecules/SkeletonLoader/SkeletonLoader';

function TableSkeleton({ tableOnly, rowsLength }) {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <div>
      {!tableOnly ? (
        <div className="d-flex a-stretch m-b-20 mobile-d-col">
          <SkeletonLoader
            radius={5}
            width={isMobile ? '100%' : 'calc(32% - 20px)'}
            height={50}
            className="m-r-20 mobile-m-r-0 mobile-m-b-20"
          />
          <SkeletonLoader
            radius={5}
            width={isMobile ? '100%' : 'calc(32% - 20px)'}
            height={50}
            className="m-r-20 mobile-m-r-0 mobile-m-b-20"
          />
        </div>
      ) : null}

      <SkeletonLoader radius={5} height={60} />

      {Array.from(Array(rowsLength || 5).keys()).map((_, index) => (
        <div key={index} className="d-flex j-space-btw">
          <SkeletonLoader
            radius={5}
            height={57}
            width={isMobile ? 'calc(100% - 200px - 10px)' : '200px'}
            className="m-t-10"
          />

          <SkeletonLoader
            radius={5}
            height={57}
            width={isMobile ? '200px' : 'calc(100% - 200px - 10px)'}
            className="m-t-10"
          />
        </div>
      ))}
    </div>
  );
}

TableSkeleton.propTypes = {
  tableOnly: PropTypes.bool,
  rowsLength: PropTypes.number,
};

TableSkeleton.defaultProps = {
  tableOnly: false,
  rowsLength: null,
};

export default TableSkeleton;
